import { FC } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";

import { Box, Container, MsLink, NavPromoBanner, Tag, Text, getThemeValue } from "@ms/gatsby-theme";

export interface SuperBannerProps {
  bannerData: NavPromoBanner;
}

export const SuperBanner: FC<SuperBannerProps> = ({ bannerData }) => {
  return (
    <Box
      sx={{
        height: (t) => getThemeValue(t, "sizes.superBannerHeight"),
        width: "full",
        bg: "goldPrimary",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <MsLink
        data-testid="superBanner"
        to={bannerData.link ?? ""}
        variant="textLinkPrimary"
        sx={{
          bg: "goldPrimary",
          height: "full",
          textDecoration: "none",
          width: "screenWidth",
          color: "black",
          "&:hover": { color: "black" },
        }}
      >
        <Container
          variant="wide"
          sx={{
            bg: "goldPrimary",
            display: "flex",
            alignItems: "center",
            height: "full",
            justifyContent: ["center", null, null, "flex-start"],
          }}
        >
          <Tag
            responsive={true}
            sx={{
              marginLeft: "0.65rem",
              display: ["none", null, null, "flex"],
              "> span": { fontSize: ["fs10", null, "fs12"] },
              mr: "s300",
            }}
          >
            {bannerData?.badge}
          </Tag>
          <ReactMarkdown
            components={{
              p: ({ children }) => <Text variant="sansMicro02RegularPlus">{children}</Text>,
              a: ({ children }) => {
                return (
                  <Text
                    variant="sansMicro02RegularPlus"
                    sx={{
                      letterSpacing: "tight400",
                      textAlign: ["left", null, null, "center"],
                      fontWeight: "medium",
                      textDecoration: "underline",
                    }}
                  >
                    {children}
                  </Text>
                );
              },
            }}
          >
            {bannerData?.description}
          </ReactMarkdown>
        </Container>
      </MsLink>
    </Box>
  );
};
